<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="unSXyAQidBLNjSjLvqXnS84"><p class="Perfect-Center"><br/></p>
<p class="Perfect-Center"><br/></p>
<p class="Perfect-Center">For Kelliann</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3edfe028